export default "__VITE_ASSET__DLaaJ4Fp__"